import { Component } from 'react';
import Loading from '../../components/Loading';
import Authors from '../Authors';
import { withTranslation } from 'react-i18next';

class AuthorsContainer extends Component {
    constructor() {
        super();

        this.state = {};
    }

    render() {
        const { t } = this.props;

        const redirectButton = (
            <div className="redirect-button">
                {this.props.isLink ? (
                    <a className="bg-khaki button-close" href={this.props.href}>
                        {this.props.buttonName}
                    </a>
                ) : (
                    <div>
                        <button
                            className="bg-khaki button-close"
                            onClick={this.props.onClick}
                            disabled={this.props.loading}
                        >
                            {this.props.buttonName}
                        </button>
                        <div className="d-flex justify-content-center pt-2">
                            {this.props.loading && <Loading onlyPreloader />}
                        </div>
                    </div>
                )}
            </div>
        );
        return (
            <div id="authors-page">
                <div className="row card-row d-flex" id="authors-content">
                    <div className="col-12">
                        <Authors
                            content_id="authors-content"
                            parent_id="authors-page"
                            component="Authors"
                            domain={this.props.domain}
                            plan_type={this.props.plan_type}
                            message={this.props.message}
                            redirectButton={redirectButton}
                        />
                    </div>
                </div>
                {this.props.message && (
                    <div className="row card-row d-flex" id="authors-content">
                        <div className="col-12">
                            <div className="card table-main rounded-main overflow-hidden">
                                <div className="card-header">
                                    <p className="card-title">
                                        {t('discover.authors.author_topical_authority.header')}
                                    </p>
                                </div>
                                <div className="card-body">
                                    <small className="d-block card-sub-title text-muted text-capitalize py-2">
                                        {' '}
                                        <i className="icon-lightbulb-solid lightbulb-styles"></i>{' '}
                                        {t('discover.authors.author_topical_authority.message')}
                                    </small>
                                    <img
                                        src={this.props.module_2_img}
                                        alt={t('discover.authors.author_topical_authority.header')}
                                        className="w-100"
                                        loading="lazy"
                                    />
                                </div>
                                {redirectButton}
                            </div>
                        </div>
                        <div className="row card-row d-flex" id="authors-content">
                            <div className="col-12">
                                <div className="card table-main rounded-main overflow-hidden">
                                    <div className="card-header">
                                        <p className="card-title">
                                            {' '}
                                            {t(
                                                'discover.authors.detailed_author_performance.header',
                                            )}
                                        </p>
                                    </div>
                                    <div className="card-body">
                                        <img
                                            src={this.props.module_3_img}
                                            alt={t(
                                                'discover.authors.detailed_author_performance.header',
                                            )}
                                            className="w-100"
                                            loading="lazy"
                                        />
                                    </div>
                                    {redirectButton}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
export default withTranslation()(AuthorsContainer);
